module.exports = __webpack_public_path__ + "staticV3/img/d4e8b6f8.empty-coupon-douyin.png";